class HeroProductHotspots extends HTMLElement {
  constructor() {
    super();
    this.productHotspots = this.querySelectorAll('.js-product-hotspot');
    this.productHolder = this.querySelector('.hero__product-holder');
    this.init();
  }

  init() {
    // Set initial state to open
    this.productHotspots.forEach(hotspot => {
      hotspot.setAttribute('aria-expanded', 'true');
    });

    this.productHotspots.forEach(hotspot => {
      hotspot.addEventListener('click', this.handleHotspotClick.bind(this));
    });

    // Add event listeners to close buttons
    this.querySelectorAll('.hero__product-card-close').forEach(closeButton => {
      closeButton.addEventListener('click', (event) => {
        const card = event.target.closest('.hero__product-card');
        const hotspotHandle = card.dataset.productCard;
        const hotspot = this.querySelector(`[data-product-handle="${hotspotHandle}"]`);
        
        card.classList.add('hidden');
        hotspot.setAttribute('aria-expanded', 'false');
      });
    });
  }

  handleHotspotClick(event) {
    const hotspot = event.currentTarget;
    const productCard = this.querySelector(`[data-product-card="${hotspot.dataset.productHandle}"]`);
    const isExpanded = hotspot.getAttribute('aria-expanded') === 'true';
    
    this.closeAllProducts();
    
    if (!isExpanded && productCard) {
      productCard.classList.remove('hidden');
      hotspot.setAttribute('aria-expanded', 'true');
      
      // Check for overflow and adjust position
      this.adjustCardPosition(productCard);
    }
  }

  adjustCardPosition(card) {
    const cardRect = card.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    
    // Check if card overflows on the right side
    if (cardRect.right > viewportWidth) {
      card.classList.add('position-left');
    } else {
      card.classList.remove('position-left');
    }
    
    // Check if card overflows on the left side
    if (cardRect.left < 0) {
      card.classList.remove('position-left');
    }
  }

  closeAllProducts() {
    this.querySelectorAll('.hero__product-card').forEach(card => {
      card.classList.add('hidden');
    });
    this.productHotspots.forEach(hotspot => {
      hotspot.setAttribute('aria-expanded', 'false');
    });
  }
}

customElements.define('hero-product-hotspots', HeroProductHotspots); 